import { Link } from 'react-router-dom';
import { Mail, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { icon: <Instagram className="w-5 h-5" />, url: 'https://www.instagram.com/growon__community', label: 'Instagram' },
    { icon: <Linkedin className="w-5 h-5" />, url: 'https://www.linkedin.com/posts/nextgen-india9_official-announcement-we-would-like-to-activity-7411688145773170688-_TRV', label: 'LinkedIn' },
    { icon: <Mail className="w-5 h-5" />, url: 'mailto:growoncommunity@gmail.com', label: 'Email' },
  ];

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/mentors', label: 'Mentors' },
    { path: '/workshops', label: 'Workshops' },
    { path: '/community', label: 'Community' },
    { path: '/team', label: 'Team' },
  ];

  const platformLinks = [
    { path: '/collaborations', label: 'Collaborations' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <footer className="bg-[#005461] text-white">
      <div className="container mx-auto px-4 py-12">
        
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          
          {/* Brand Column with Circular Logo */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-center gap-3 mb-6">
              <div className="relative w-12 h-12">
                {/* White background */}
                <div className="absolute inset-0 bg-white rounded-full"></div>
                {/* Circular Logo with cropping */}
                <div className="absolute inset-0 rounded-full overflow-hidden">
                  <img 
                    src="/logo.png" 
                    alt="GrowOn Logo" 
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = `
                        <div class="w-full h-full bg-[#0C7779] rounded-full flex items-center justify-center">
                          <span class="font-bold text-white text-lg">G</span>
                        </div>
                      `;
                    }}
                  />
                </div>
              </div>
              <div className="text-left">
                <h2 className="text-xl font-bold">GrowOn</h2>
                <p className="text-sm text-white/70">Mentorship Community</p>
              </div>
            </Link>
            <p className="text-white/80 text-sm leading-relaxed max-w-md">
              A student-led community providing practical guidance, real-world projects, 
              and direct mentorship for career growth.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-4">
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Platform</h3>
            <div className="space-y-2">
              {quickLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  className="block text-white/70 hover:text-white transition-colors text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Platform Links */}
          <div className="md:col-span-4">
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Resources</h3>
            <div className="space-y-2">
              {platformLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  className="block text-white/70 hover:text-white transition-colors text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            
            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors p-2 hover:bg-white/10 rounded-lg"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>

            {/* Copyright */}
            <div className="text-center md:text-right">
              <div className="text-white/60 text-sm mb-1">
                © {new Date().getFullYear()} GrowOn Community
              </div>
              <div className="text-white/40 text-xs">
                Building real pathways, together.
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;